'use client'

import Modal from '@/components/elements/Modal'
import { toast } from '@/lib/toast'
import { useAddressForm } from '@/lib/commerce/hooks'
import { AddressFormFields } from './AddressList'

interface AddressEditProps {
  open: boolean
  setOpen: (open: boolean) => void
  address: any
  addressField: any
  vendor?: any
  updateAddress: (id: string, body: any) => Promise<boolean>
  submitting: boolean
}

export default function AddressEdit({ open, setOpen, address, addressField, vendor, updateAddress, submitting }: AddressEditProps) {
  const form = useAddressForm({ addressField, vendor, initial: address })

  const handleSave = async () => {
    const v = form.validate()
    if (!v.ok) return toast.error(v.error)
    const ok = await updateAddress(address.id, form.compose())
    if (ok) setOpen(false)
  }

  return (
    <Modal open={open} setOpen={setOpen} isSaveActive={!submitting} showCancel={false} saveAction={handleSave} saveText={submitting ? 'Хаягийг хадгалж байна...' : 'Хадгалах'} isLoading={submitting} title="Хаяг засах" description="" border={vendor?.border} color={vendor?.color?.primary}>
      <AddressFormFields form={form} vendor={vendor} />
    </Modal>
  )
}
